export const data = [
    {
        "name": "Photo 1",
        "url": "/images/img1.jpg",
        "description": "Photo 1 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    },
    {
        "name": "Photo 2",
        "url": "/images/img2.jpg",
        "description": "Photo 2 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    },
    {
        "name": "Photo 3",
        "url": "/images/img3.jpg",
        "description": "Photo 3 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    },
    {
        "name": "Photo 4",
        "url": "/images/img4.jpg",
        "description": "Photo 4 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    },
    {
        "name": "Photo 5",
        "url": "/images/img5.jpg",
        "description": "Photo 5 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    },
    {
        "name": "Photo 6",
        "url": "/images/img6.jpg",
        "description": "Photo 6 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    },
    {
        "name": "Photo 7",
        "url": "/images/img7.jpg",
        "description": "Photo 7 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    },
    {
        "name": "Photo 8",
        "url": "/images/img8.jpg",
        "description": "Photo 8 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    },
    {
        "name": "Photo 9",
        "url": "/images/img9.jpg",
        "description": "Photo 9 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    },
    {
        "name": "Photo 10",
        "url": "/images/img10.jpg",
        "description": "Photo 10 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    },
    {
        "name": "Photo 11",
        "url": "/images/img11.jpg",
        "description": "Photo 11 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    },
    {
        "name": "Photo 12",
        "url": "/images/img12.jpg",
        "description": "Photo 12 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    },
    {
        "name": "Photo 13",
        "url": "/images/img13.jpg",
        "description": "Photo 13 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    },
    {
        "name": "Photo 14",
        "url": "/images/img14.jpg",
        "description": "Photo 14 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    },
    {
        "name": "Photo 15",
        "url": "/images/img15.jpg",
        "description": "Photo 15 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    },
    {
        "name": "Photo 16",
        "url": "/images/img16.jpg",
        "description": "Photo 16 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    },
    {
        "name": "Photo 17",
        "url": "/images/img17.jpg",
        "description": "Photo 17 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    },
    {
        "name": "Photo 18",
        "url": "/images/img18.jpg",
        "description": "Photo 18 description",
        "date": "15/06/2023",
        "type": "image/jpg",
    }
]